export const EditableField = ({
	editable,
	alt,
	register,
	name,
	error,
	required = false,
}) =>
	editable ? (
		<input
			{...register(name, {
				required: { value: required, message: "Required" },
			})}
			style={{ borderRadius: 5, border: "1px solid #b6c1db" }}
			className={`form-control form-control-sm ${error && "is-invalid"}`}
		/>
	) : (
		alt || null
	);
